import { Drawer as MuiDrawer } from '@mui/material';
import {
  alpha,
  styled,
} from '@mui/material/styles';

export const Drawer = styled(MuiDrawer)(({ theme }) => ({
  '& > .MuiDrawer-paper': {
    top: '67px',
    margin: 'calc(5px + var(--sandbox-banner-height, 0px)) 7px 7px 10px',
    borderRadius: 6,
    width: 74,
    borderRight: 'none',
    boxShadow: `1px 1px 12px ${alpha(theme.palette.common.white, 0.03)}`,
  },
}));
